module.exports = __webpack_public_path__ + "img/332.443f1718.jpg";